import React from 'react';

// Lifted verbatim from MetaPerformance/GooglePerformance, where it existed
// twice with identical bodies.
const ScoreBadge = ({ score, status, size = 'md' }) => {
  const colors = {
    good: 'bg-emerald-500/20 text-emerald-400 ring-emerald-500/30',
    warning: 'bg-amber-500/20 text-amber-400 ring-amber-500/30',
    critical: 'bg-red-500/20 text-red-400 ring-red-500/30',
    inactive: 'bg-zinc-500/20 text-zinc-400 ring-zinc-500/30'
  };

  const sizes = {
    sm: 'text-xs px-2 py-0.5',
    md: 'text-sm px-2.5 py-1',
    lg: 'text-base px-3 py-1.5'
  };

  return (
    <span className={`${colors[status]} ${sizes[size]} rounded-full font-bold ring-1 inline-flex items-center gap-1.5`}>
      <span className={`w-1.5 h-1.5 rounded-full ${status === 'good' ? 'bg-emerald-400' : status === 'warning' ? 'bg-amber-400' : status === 'critical' ? 'bg-red-400' : 'bg-zinc-400'}`}></span>
      {score}
    </span>
  );
};

export default ScoreBadge;
